define('presentation/release/presentationObjects/accountPresentationObject',[], function () {
    return function () {
        let self = this;

        self.accountId = ko.observable("");
    };
});
